import { render } from "./EditTimeSheetSetting.vue?vue&type=template&id=21e4f60c&scoped=true"
import script from "./EditTimeSheetSetting.vue?vue&type=script&lang=js"
export * from "./EditTimeSheetSetting.vue?vue&type=script&lang=js"

import "./EditTimeSheetSetting.vue?vue&type=style&index=0&id=21e4f60c&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e4f60c"]])

export default __exports__